import { Box, styled, Typography } from '@mui/material';

export const DataPointTooltip = ({ label, value }: { label: string; value: string }) => {
  return (
    <StyledTooltipBox>
      <Typography variant="body1">{label}</Typography>
      <StyledTooltipValue>{value}</StyledTooltipValue>
    </StyledTooltipBox>
  );
};

const StyledTooltipBox = styled(Box)(({ theme }) => ({
  padding: '8px',
  backgroundColor: theme.palette.lwWhite[100],
  borderRadius: '12px',
  boxShadow: theme.shadows[3],
}));

const StyledTooltipValue = styled(Typography)(({ theme }) => ({
  '&.MuiTypography-root': {
    fontSize: '14px',
    color: theme.palette.lwPrimary[100],
  },
}));
